import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
} from "@chakra-ui/react";
import { GenericError } from "src/components/Feedback/GenericError";
import { RemoteDataView } from "src/components/Layout/RemoteDataView";
import * as FSR from "src/generated/hooks/form-service/requests";
import { useRemoteDataRestQuery } from "src/hooks/useRemoteDataQuery";
import { isNonEmptyString } from "src/services/predicates";
import { ReceiptContent, ReceiptContentLoading } from "./ReceiptContent";

interface ReceiptModalProps {
  isOpen: boolean;
  onClose: () => void;
  paymentId: string | null;
}

export const ReceiptModal: React.FC<ReceiptModalProps> = ({
  isOpen,
  onClose,
  paymentId,
}) => {
  const remoteData = useRemoteDataRestQuery({
    queryKey: ["GetAdminPaymentReceipt", paymentId],
    queryFn: () => {
      if (!isNonEmptyString(paymentId)) {
        throw new Error("Missing paymentId");
      }
      return FSR.getAdminPaymentReceipt({ path: { paymentId } }).then(
        (resp) => resp.data
      );
    },
    enabled: isOpen && isNonEmptyString(paymentId),
  });

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Receipt</ModalHeader>
        <ModalCloseButton />
        <ModalBody paddingBottom="6">
          <RemoteDataView
            remoteData={remoteData}
            error={() => <GenericError />}
            loading={<ReceiptContentLoading />}
            reloading={null}
          >
            {({ data }) => (
              <ReceiptContent
                data={{
                  id: data.id,
                  name: data.paymentTemplate.name,
                  amountInCents: data.amountInCents,
                  currency: data.currency,
                  paymentStatus: data.paymentStatus,
                  paidAt: data.paidAt,
                  studentName: `${data.person.firstName ?? ""} ${
                    data.person.lastName ?? ""
                  }`.trim(),
                  form: null,
                  receiptUrl: data.receiptUrl ?? null,
                }}
              />
            )}
          </RemoteDataView>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
